import Router from '../Router';
import {decode} from 'querystring';

export const redirectTo = (url, options = {scrollToTop: false}) => {
  Router.replaceRoute(url);

  if (options.scrollToTop) {
    window.scrollTo(0, 0);
  }
};

export const transitionTo = (url, options = {scrollToTop: false}) => {
  Router.setRoute(url);

  if (options.scrollToTop) {
    window.scrollTo(0, 0);
  }
};

export const transitionToChannel = channelId =>
  transitionTo(`/m/buzz/channel/${channelId}`);

export const navigateTo = url => {
  window.location = url;
};

export const back = () => {
  window.history.back();
};

export const reload = () => {
  window.location.reload();
};

export const parseQuerystring = (str = window.location.search) =>
  decode(str.split('?')[1] || '');

export const getSearchParam = (key, url = window.location.search) => {
  const params = new URLSearchParams(url);
  return params.get(key);
};

export const urnToId = urn => urn.split(':').pop();

export const getHost = url => {
  const hostname = new URL(url).hostname;
  const segments = hostname.split('.');
  return segments.slice(-2).join('.');
};

export const isPublicationGroup = id => !!(id && String(id).startsWith('ss:'));

export const getPublicationGroupParentId = id => {
  if (!id) return null;
  const match = String(id).match(/^(ss:\d+):\d+$/);
  return match ? match[1] : null;
};

const schema = /^https?:/;
export const normalize = href => {
  try {
    href = href.match(schema) ? href : `http://${href}`;
    return new URL(href).href;
  } catch {
    return null;
  }
};

export const getReferrer = () =>
  window.location === window.parent.location
    ? window.location.href
    : document.referrer;

export const stripQuerystring = url => (url ? url.split('?')[0] : url);

export const downloadBlob = (blob, fileName) => {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = fileName;
    a.dispatchEvent(
      new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window})
    );
  }
};
